import React from 'react';
import Header from './Header'
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './index.css';
import './style.css';
import { BrowserRouter as Router, Routes, Route}
	from 'react-router-dom';
import Go from './pages/Go';
import About from './pages/About';
import Blues from './pages/Blues';
import Home from './pages/Home';
import Contact from './pages/Contact';

function App() {
return (
	<Router>
    <Header />
	<Navbar />
	<Routes>
		<Route exact path='/'  element={<Home />} />
		<Route exact path='/Go'  element={<Go />} />
		<Route exaxt path='/About' element={<About/>} />
		<Route exaxt path='/Blues' element={<Blues/>} />
		<Route exact path='/Contact' element = {<Contact/>} />
	</Routes>
    <Footer />
	</Router>
);
}

export default App;
